$(function() {
  var allItem = $('.ie-side-nav .ie-side-nav--item');
  // 遍历左边栏，展示相应的产品列表
  allItem.each(function(idx) {
    if($(this).hasClass('active')) {
      $('.side-nav-layout--right').eq(idx).show();
      setMore(idx);
    }

    // 点击切换产品
    $(this).click(function() {
      allItem.removeClass('active').eq(idx).addClass('active');
      $('.side-nav-layout--right').hide().eq(idx).show();
      setMore(idx);
    })

  });

  // 根据产品数量控制第一页高度和是否显示加载更多按钮
  function setMore(idx) {
    var curPro = $('.product-list').eq(idx); // 当前的系列的右侧列表
    var curProLen = curPro.children('li').length; // 当前的系列下的产品数量
    var curProChild = curPro.children('li:eq(0)'); // 当前系列下的第一个子产品单元
    var parProductWrapWidth = curPro.width(); // 宽度
    var productListHeight = curProChild.height() + parseInt(curProChild.css('margin-bottom')); // 当前系列下的第一个子产品单元的实际高度
    var productListWidth = curProChild.width(); // 当前系列下的第一个子产品单元的内容宽度
    var colNum = Math.floor(parProductWrapWidth / productListWidth); // 不同分辨率下的列数
    var rowNum = Math.ceil(15 / colNum); // 一页的行数
    var page = 1; // 页数
    // 设置最大高度
    curPro.css({
      'max-height': rowNum * page * productListHeight,
      'overflow': 'hidden'
    });
    // 点击左侧切换时还原点击按钮
    var curMore = $('.product-more').eq(idx);
    if(curProLen > 15) {
      curMore.children('a').text('点击加载更多...');
    }

    // 点击加载更多
    curMore.off('click').click(function() {
      page ++;
      curPro.stop().animate({
        'max-height': rowNum * (page - 1) * productListHeight
      }, 1000).stop().animate({
        'max-height': rowNum * page * productListHeight
      }, 1000, function() {
        // 判断是否是最后一页
        if(rowNum * colNum * page >= curProLen) {
          curMore.off('click').children('a').text('-已经到底了-');
        }
      });
    });
  };
});
